import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { Grid, Typography } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const StyledButton = styled(Button)({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start", // Align items to the start (left)
  width: "100%", // Set width to 100%
  padding: "5px 20px",
  textTransform: "none", 
  backgroundColor: "#eaeaea",
});

const LogoImage = styled("img")({
  width: "30px",
  marginRight: "8px",
});

const LogoButton = ({ logoSrc, altText, buttonText, onClick, isDisabled }) => {
  return (
    <StyledButton
      variant="contained"
      size="medium"
      disabled={isDisabled}
      onClick={onClick}
      endIcon={<ArrowDropDownIcon sx={{ color: "#1D1D1D" }} />}
    >
      <Grid container alignItems="center">
        <LogoImage src={logoSrc} alt={altText} />
        <span style={{ flexGrow: 1, textAlign: "center" }}>
          <Typography sx={{ color: "#1D1D1D" }}>{buttonText}</Typography>
        </span>
      </Grid>
    </StyledButton>
  );
};

export default LogoButton;
